import * as React from 'react'
import Image from 'next/image'
import styled, { css } from '@xstyled/styled-components'
import { initCanvas } from './draw'

const BackgroundWrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: ${theme.zIndices.canvas};
    pointer-events: none;
    background: linear-gradient(90deg, #a56c81 0%, #fdf4f8 49%, #a56c81 100%);
  `}
`

const Canvas = styled.canvas`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    filter: blur(50px);
  `}
`

interface BackgroundElementProps {
  width: string
  height?: string
  top?: string | number
  left?: string | number
  bottom?: string | number
  right?: string | number
  maxwidth?: string
}

const BackgroundElement = styled.div<BackgroundElementProps>`
  ${({ width, height, top, left, bottom, right, maxwidth }) => css`
    position: absolute;
    width: ${width};
    height: ${height || 'auto'};
    top: ${top || 'auto'};
    left: ${left || 'auto'};
    bottom: ${bottom || 'auto'};
    right: ${right || 'auto'};
    max-width: ${maxwidth || 'auto'};
    z-index: 1;
  `}
`

const { useEffect, useRef } = React

export const Background: React.FC = (props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (!canvasRef.current) return
    const teardown = initCanvas(canvasRef.current)
    return () => teardown()
  }, [canvasRef.current])

  return (
    <BackgroundWrapper>
      <BackgroundElement
        left="80px"
        top="25%"
        width="200px"
        maxwidth="15vw"
      ></BackgroundElement>
      <Canvas ref={canvasRef} />
    </BackgroundWrapper>
  )
}
